<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import { inputLabels } from "../lang";
  import Icon from "./Icon.svelte";
  import Label from "./Label.svelte";

  export let label: string;
  export let value: unknown = null;
  export let inputmode: "numeric" = null;
  export let readonly = false;
  export let disabled = false;
  export let clearable = false;
  export let info = "";

  const dispatch = createEventDispatcher<{ clear: never }>();
  const id = crypto.randomUUID();

  function clear() {
    value = "";
    dispatch("clear");
  }
</script>

<div class="Input">
  <Label {id} {info}>
    {label}
  </Label>
  <input
    class="Input-input"
    class:is-clearable={clearable}
    {id}
    type="text"
    {inputmode}
    bind:value
    {readonly}
    {disabled}
  />
  {#if clearable && value}
    <button
      class="Input-clear"
      on:click={clear}
      aria-label={inputLabels.clear}
      aria-controls={id}
    >
      <Icon type="close" />
    </button>
  {/if}
</div>

<style>
  .Input {
    position: relative;
  }

  .Input-input {
    border: var(--size-1) solid var(--color-gray-border);
    border-radius: var(--size-20);
    color: var(--color-blue);
    padding-block: var(--size-8);
    padding-inline: var(--size-18);
  }

  .Input-input.is-clearable {
    padding-inline-end: var(--size-40);
  }

  .Input-clear {
    color: var(--color-blue);
    display: flex;
    font-size: var(--size-20);
    inset-block-end: var(--size-9);
    inset-inline-end: var(--size-13);
    position: absolute;
  }
</style>
